import * as React from 'react';
import { SectionPanel } from 'ui/section-panel/section-panel';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { CodetableItemFormComponentProps } from 'app/area/codetable/item/codetable-item-form';
import { ReadOnlyType, SlotProps } from 'app/area/codetable/item/types';
import { renderSlot } from 'app/area/codetable/item/screen-renderer/render-slot';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { TileViewComponent } from 'ui/tile-view/tile-view';
import {
  ConversionFactorTile
} from 'app/area/codetable/item/screen-renderer/screen-pickers/conversion-factors/tile/conversion-factor-tile';
import { UoMConversionType } from 'app/area/codetable/item/screen-renderer/screen-pickers/conversion-factors/uom-conversion-type';
import styles from './conversion-factors.scss';

export const ConversionFactors = (props: Partial<CodetableItemFormComponentProps> & SlotProps &
{ codeCategoryLabel?: (translation: CodetableTranslation) => string; }) => {

  const { breadcrumbs, translation, sectionSlots, sectionRef, codeItem, clearByKey, readOnlyConfig, updateByKey, removeConversionFactor,
    codetableOptions, resetValidation, updateValidation, loadCodetableOptions, options, validation, updateConversionFactor
  } = props;

  const readOnly = readOnlyConfig?.[ReadOnlyType.all];

  const substanceConversionFactor = codeItem?.substanceConversionFactor ?? [];

  const existingKeys = substanceConversionFactor.map(conversionFactor => conversionFactor.uomConversionType);

  return <div ref={sectionRef}>
    <SectionPanel
      className="admin-paper-top-panel"
      componentId="details"
      validation={undefined}
      info={{ text: translation.conversion_factors }}
      label={{ visible: true, text: translation.conversion_factors }} />
    <MainGridContainer>
      <div className="row">
        {renderSlot(sectionSlots, 'top', props)}
        {
          substanceConversionFactor.length === 0 && readOnly
            ? <div className={`no-content ${styles.noConversionFactors}`}>{translation.no_conversion_factors}</div>
            : <TileViewComponent
              componentId="conversion-factor-tile"
              className={styles.tileViewComponent}
              textAddItem={translation.add_conversion_factor}
              label={{ required: false, visible: false }}
              readOnly={readOnly}
              enabledChildEntityOperations={{ add: true }}
              addButton={<UoMConversionType
                breadcrumbs={breadcrumbs}
                existingKeys={existingKeys}
                options={options}
                updateByKey={updateByKey}
                clearByKey={clearByKey}
                codetableOptions={codetableOptions}
                codeItem={codeItem}
                resetValidation={resetValidation}
                updateValidation={updateValidation}
                loadCodetableOptions={loadCodetableOptions}
                translation={translation} />}>
              {substanceConversionFactor.map((conversionFactor, index) =>
                <ConversionFactorTile
                  key={index}
                  breadcrumbs={breadcrumbs}
                  conversionFactor={conversionFactor}
                  clearByKey={clearByKey}
                  codetableOptions={codetableOptions}
                  updateByKey={updateByKey}
                  codeItem={codeItem}
                  resetValidation={resetValidation}
                  updateValidation={updateValidation}
                  loadCodetableOptions={loadCodetableOptions}
                  translation={translation}
                  validation={validation}
                  readOnlyConfig={readOnlyConfig}
                  removeConversionFactor={removeConversionFactor}
                  updateConversionFactor={updateConversionFactor} />)
              }
            </TileViewComponent>
        }
        {renderSlot(sectionSlots, 'bottom', props)}
      </div>
    </MainGridContainer>
  </div>;
};
